/**
 * Describes a store, that can be accessed and modified via HTTP protocol.
 */
export class HttpStoreDescriptor {
    static TYPE = "https://ofn.gov.cz/store-descriptor/http";
    type;
    url;
    isReadOnly;
    constructor() {
        this.type = HttpStoreDescriptor.TYPE;
        this.isReadOnly = true;
        this.url = null;
    }
    static is(storeDescriptor) {
        return storeDescriptor.type === HttpStoreDescriptor.TYPE;
    }
}
//# sourceMappingURL=http-store-descriptor.js.map